import { render, staticRenderFns } from "./LottieCheck.vue?vue&type=template&id=6b1211c4&scoped=true&"
import script from "./LottieCheck.vue?vue&type=script&lang=js&"
export * from "./LottieCheck.vue?vue&type=script&lang=js&"
import style0 from "./LottieCheck.vue?vue&type=style&index=0&id=6b1211c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1211c4",
  null
  
)

component.options.__file = "LottieCheck.vue"
export default component.exports